"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";

const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY ?? "";
const posthogUiHost = process.env.NEXT_PUBLIC_POSTHOG_HOST ?? "https://eu.posthog.com";

const isPosthogLoaded = () => (posthog as { __loaded?: boolean }).__loaded === true;

if (typeof window !== "undefined" && posthogKey && !isPosthogLoaded()) {
  posthog.init(posthogKey, {
    api_host: "/ph",
    ui_host: posthogUiHost,
    capture_pageview: false,
    capture_pageleave: true,
    session_recording: {
      maskAllInputs: true
    }
  });
}

export function PostHogProviderClient({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!posthogKey) {
      return;
    }
    const search = searchParams?.toString();
    const url = search ? `${pathname}?${search}` : pathname;
    posthog.capture("$pageview", { $current_url: url });
  }, [pathname, searchParams]);

  if (!posthogKey) {
    return <>{children}</>;
  }

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
